export enum ArchitectureType {
    RESNET18 = 'RESNET18',
    RESNET34 = 'RESNET34',
    RESNET50 = 'RESNET50',
    RESNET101 = 'RESNET101',
    RESNET152 = 'RESNET152',
    GOOGLENET = 'GOOGLENET',
}

export enum PretrainedWeights {
    not_pretrained = 'not_pretrained',
    moco_conv5_robocloud = 'moco_conv5_robocloud',
    moco_v2_800ep_pretrain = 'moco_v2_800ep_pretrain',
}
